import { createSlice } from '@reduxjs/toolkit'

export const paramSlice = createSlice({
  name: 'param',
  initialState: {
    value:"ירושלים",
  },
  reducers: {
    setParam: (state, action) => {
      state.value= action.payload


    },

  },
})

// Action creators are generated for each case reducer function
export const { setParam } = paramSlice.actions

export default paramSlice.reducer